const {
  num,
  listBookingHours
} = require('./utilities.jsx');
module.exports = function getServiceBookingErrors(booking, service) {
  const range_end = num(service.open_range_end, 0);
  const range_start = num(service.open_range_start, 0);
  const range_hours_count = range_end - range_start;

  // plage horaire non paramétrée
  if (range_hours_count > 0 === false) return true;
  const hours_list = Array.from({
    length: range_hours_count
  }).map(function (_v, i) {
    return String(range_start + i);
  });
  const booking_hours = listBookingHours({
    date: booking.date,
    start_hour: booking.start_hour,
    end_hour: booking.end_hour,
    schedule: booking.coworking_space.schedule || {}
  });
  const is__valid = hours_list.some(hour => booking_hours.includes(hour));
  if (is__valid) return true;
  const error = {
    error: 'Ce service n\'est pas disponible pour le créneau de votre réservation.'
  };
  return error;
};
